import { useQuery } from '@tanstack/react-query'
import { useRemoteClientGet } from '../../../../../configs/http-client'

export const loadAtributes = () => {
  const { remoteClientGet } = useRemoteClientGet()
  return useQuery<{ data: { data: any } }>({
    queryKey: ['enviroments'],
    queryFn: () => remoteClientGet('/contratos/atributos'),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false
  })
}
